<template>
  <div>
    <div v-show="Mode==='Merchant'">
      <populate-form
        formTitle="商家與分店帳號管理"
        fkey="mm01"
        ref="filterMerchantForm"
        populateOptionVar="filterMerchantOptions"
        formDataObjVar="filterMerchantFormObj"
        :validatePrompt="false"
        :parentVue="this"
      ></populate-form>
      <back-to-top :text="scrollHint"></back-to-top>
      <b-table stacked="sm" class="" striped hover :items="Merchants" :fields="merchantFields">
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click.stop="goMerchant(row)" class="mr-1">
            分店管理
          </b-button>
          <b-button size="sm" @click.stop="editMerchant(row)" class="mr-1">
            編輯
          </b-button>
        </template>
      </b-table>
    </div>
    <div v-show="Mode==='MerchantStore'">
      <populate-form
        :formTitle="FocusedMerchant.merchant_name+'_分店帳號管理'"
        fkey="mm02"
        ref="filterStoreForm"
        populateOptionVar="filterStoreOptions"
        formDataObjVar="filterStoreFormObj"
        :validatePrompt="false"
        :parentVue="this"
      ></populate-form>
      <b-table stacked="sm" class="" striped hover :items="FilteredStores" :fields="storeFields">
        <template v-slot:cell(actions)="row">
          <div v-if="row.item.src_type===0">
            <b-button disabled v-if="row.item.is_super_manage==1" class="mr-1">總店</b-button>
            <!--新流程固定會建無密碼店長所以之後是用不到的-->
            <b-button size="sm" v-if="row.item.account==='' && $bus.getRole() === 'admin' " @click.stop="createAdminAccount(row)" class="mr-1">
              建立店長帳號
            </b-button>
            <b-button size="sm" @click.stop="goAccount(row)" class="mr-1">
              帳號管理
            </b-button>
            <!--adm_tel沒有設定時才讓後台修改店長密碼可以使用-->
            <b-button size="sm" v-if="row.item.account!==''&&row.item.new_adm_account&&row.item.adm_tel!==''" @click.stop="sendNewAdmin(row.item)" class="mr-1">
              發送密碼設定簡訊{{row.item.sent_not_expired?'(已寄出未過期)':''}}
            </b-button>
            <b-button size="sm" v-if="row.item.account!==''&&(row.item.adm_tel===''||$bus.getRole()==='merchant')" @click.stop="editAdminPwd(row)" class="mr-1">
              修改店長密碼
            </b-button>
            <b-button size="sm" @click.stop="editStore(row, row.index, $event.target)" class="mr-1">
              編輯
            </b-button>
          </div>
          <div v-if="row.item.src_type === 1">
            <b-button disabled>來自:{{row.item.supplier}}</b-button>
          </div>
        </template>
      </b-table>
    </div>
    <div v-show="Mode==='MerchantAccount'">
      <populate-form
        :formTitle="FocusedMerchant.merchant_name+'_'+FocusedStore.store_name+'_分店帳號管理'"
        fkey="mm03"
        ref="filterAccountForm"
        populateOptionVar="filterAccountOptions"
        formDataObjVar="filterAccountFormObj"
        :validatePrompt="false"
        :parentVue="this"
      ></populate-form>
      <b-table stacked="sm" class="" striped hover :items="FilteredAccounts" :fields="accountFields">
        <template v-slot:cell(actions)="row">
          <b-button v-if="!row.item.last_login_time&&row.item.role_type!=='店長管理者'" size="sm" @click.stop="delSubAccount(row, row.index, $event.target)">
            刪除
          </b-button>
          <b-button v-if="row.item.last_login_time" :disabled="row.item.role_type==='店長管理者'" size="sm" @click.stop="changeSubAccountStatus(row, row.index, $event.target)">
            {{row.item.status==='active'?'停用':'再啟用'}}
          </b-button>
          <b-button size="sm" @click.stop="editSubAccount(row, row.index, $event.target)" class="ml-1">
            編輯
          </b-button>
          <b-button size="sm" :disabled="$bus.getRole()==='admin'" @click.stop="editSubAccountPwd(row, row.index, $event.target)" class="ml-1">
            重設密碼
          </b-button>
        </template>
      </b-table>
    </div>
    <b-modal 
      v-model="showModal" 
      :size="modalSize"
      centered
      hide-header
      hide-footer>
      <component 
        :is="popupItem"
        :parentVue="this"
        :cbSave="saveComp"
        :cbCancel="closePopup"
        :reloadList="refreshAccounts"
      />
    </b-modal>
  </div>
</template>

<script>

import MerchantInfo from './MerchantInfo'
import StoreInfo from './StoreInfo'
import AccountQuick from './AccountQuick'
import AccountInfo from './AccountInfo'
import {
  apiGetMerchantList,
  apiGetMerchantById,
  apiUpdateMerchant,
  apiCreateStore,
  apiUpdateStore
} from '@/api/AdminManage.js'
import {
  apiGetAccountList,
  apiDeleteMerchantAccount,
  apiChangeAccountStopStatus
} from '@/api/Merchant.js'

export default {
  name: 'MerchantManage',
  provide: function() {
    return {
      Stores: this.Stores,
      // store: store
      FilteredStores: this.FilteredStores
    }
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    MerchantInfo,
    StoreInfo,
    AccountQuick,
    AccountInfo,
  },
  data: function () {
    return {
      //當有店家層級更新成功時,skip_merchant_cache設為true,判斷cache時若該值為true則不要抓cache重抓api
      skip_merchant_cache:false,
      Mode:"Merchant",
      popupItem:"",
      showModal: false,
      modalSize: 'lg',
      CachedMerchant:Object,
      merchantFields: [
        {
          key: 'actions',
          label: '操作'
        },
        {
          key: 'supplier_id',
          label: '廠商代號',
          sortable: false
        },
        {
          key: 'merchant_name',
          label: '總管理名稱',
          sortable: false
        },
        {
          key: 'contact_tel',
          label: '電話',
          sortable: false
        },
        {
          key: 'supplier_address',
          label: '地址',
          sortable: false
        },
        {
          key: 'contact_name',
          label: '管理者',
          sortable: false
        },
        {
          key: 'super_admin_account',
          label: '帳號',
          sortable: false
        },
        {
          key: 'contact_email',
          label: '電子郵件',
          sortable: false
        },
      ],
      storeFields: [
        {
          key: 'actions',
          label: '操作'
        },
        {
          key: 'store_id',
          label: '分店代號',
          sortable: true
        },
        {
          key: 'store_name',
          label: '分店名稱',
          sortable: true
        },
        {
          key: 'store_contact_info',
          label: '電話',
          sortable: false
        },
        {
          key: 'store_address',
          label: '地址',
          sortable: true
        },
        {
          key: 'account_name',
          label: '店長',
          sortable: false
        },
        {
          key: 'account',
          label: '帳號',
          sortable: true
        }
      ],
      accountFields: [
        {
          key: 'actions',
          label: '操作'
        },
        {
          key: 'merchant_account_id',
          label: '編號',
          sortable: false
        },
        {
          key: 'account_name',
          label: '姓名',
          sortable: false
        },
        {
          key: 'role_type',
          label: '職稱',
          sortable: false
        },
        {
          key: 'account',
          label: '帳號名稱',
          sortable: false
        },
      ],
      Merchants: [],
      FocusedMerchant: Object,
      FocusedMerchantId:0,
      filterMerchantFormObj: {},
      filterMerchantOptions:[
        {
          'componentType':'text',
          'defaultValue':'',
          'akey':'FilterMerchantName',
          'col':4,
          'label':'',
          'placeholder':'供應商名稱篩選',
          'title':'輸入供應商名稱關鍵字(空白則全部)',
          'isRequired':false,
          'execCallback':this.loadMerchantsEnter
        },
        {
          'componentType':'span',
          'akey':'span1',
          'col':6,
          'placeholder':'',
          'title':'',
        },
        {
          'componentType':'b-button',
          'akey':'search',
          'col':2,
          'placeholder':'查詢',
          'execCallback':this.loadMerchants
        }
      ],
      Stores:[],
      FilteredStores:[],
      FocusedStore: Object,
      filterStoreFormObj: {},
      filterStoreOptions:[
        {
          'componentType':'b-button',
          'akey':'back',
          'col':2,
          'placeholder':'回到商家列表',
          'hide':(this.$bus.getRole() !== 'admin'),
          'execCallback':this.backToMerchantList      
        },
        {
          'componentType':'text',
          'defaultValue':'',
          'akey':'FilterStore',
          'col':2,
          'label':'',
          'placeholder':'查詢條件',
          'title':'以分店名稱篩選',
          'execCallback':this.filterStore
        },
        {
          componentType:'b-form-checkbox',
          akey:'is_open_stores_only',
          col:3,
          defaultValue: true,
          placeholder:'隱藏關閉中店家',
          title:"隱藏關閉中店家"
        },
        {
          'componentType':'b-button',
          'akey':'newStore',
          'col':2,
          'placeholder':'新店家',
          'execCallback':this.showCreateStore
        },
        {
          'componentType':'b-button',
          'akey':'search2',
          'col':1,
          'placeholder':'篩選',
          'execCallback':this.filterStore
        },
      ],
      Accounts:[],
      FilteredAccounts:[],
      accountAdminDirty:false,
      filterAccountFormObj: {},
      popupAccountFormObj: {},
      filterAccountOptions:[
        {
          'componentType':'b-button',
          'akey':'back',
          'col':2,
          'placeholder':'回到分店列表',
          'hide':(this.$bus.getRole() !== 'admin'&&(this.$bus.session&&!this.$bus.session.is_super_manage)),
          'execCallback':this.backToStoreList      
        },
        {
          'componentType':'span',
          'akey':'span1',
          'col':8,
        },
        {
          'componentType':'b-button',
          'defaultValue':'',
          'akey':'bAddAccount',
          'col':2,
          'label':'',
          'placeholder':'新增帳號',
          'title':'',
          'isRequired':false,
          disabled: (this.$bus.getRole()==='admin'&&!['sys_admin','support','support_mgr'].includes(this.$bus.session.role_type)),
          'execCallback':this.createSubAccount
        },
      ]
    }
  },
  methods: {
    showCreateStore() {
      //分店列表模式下,可以建立新店家
      this.FocusedStore = {
        is_create:true,
        store_name:'',
        store_id:'建立後自動產生',
        is_super_manage:0,
        is_open:1,
        store_contact_info:'',
        store_contact_info2:'',
        store_address:'(請輸入下面四段地址後按enter)',
        addr_city:'',
        addr_area:'',
        addr_road_part:'',
        addr_rest:'',
        header_custom_note:'',
        business_time:'',
        holiday:'',
        footer_custom_note:'',
        account_name:'自動建立',
        account:'自動建立',
        loc_desc:'',
        adm_tel:'',
        latitude:25.0,
        longitude:121.5,
        width: "400px",
        height: "250px"
      }
      this.FocusedStore.row_index = undefined
      this.popupItem = "StoreInfo"
      this.modalSize = "xl"
      this.showModal = true
    },
    saveComp(compData) {
      // console.log(compData);
      if (this.popupItem == 'StoreInfo') {
        if (!compData.is_create) {
          this.saveStore(compData)
        }
        else {
          //不要共用,這個操作必須重撈資料才能更新數據
          this.createStore(compData)
        }
      }
      else if (this.popupItem == 'MerchantInfo') {
        this.saveMerchant(compData)
      }
      else {
        //自己處理掉
        return
      }
    },
    saveStore(store) {
      console.log('411行',store);
      //alert(JSON.stringify(store))
      //return
      let rptParam = {
        'method':'updateStore',
        'merchant_store_id': store.id,
        'store_name': store.store_name,
        'store_contact_info': store.store_contact_info,
        'store_email': store.store_email,
        'store_contact_info2': store.store_contact_info2,
        'addr_city': store.addr_city,
        'addr_area': store.addr_area,
        'addr_road_part': store.addr_road_part,
        'addr_rest': store.addr_rest,
        'loc_desc': store.loc_desc,
        'header_custom_note': store.header_custom_note,
        'footer_custom_note': store.footer_custom_note,
        'business_time': store.business_time,
        'holiday': store.holiday,
        'is_open': store.is_open,
        'map_zoom': Number(store.map_zoom)
      }
      // console.log(rptParam);
      let vm = this
      apiUpdateStore(rptParam).then(function(resp){
        // let data = resp.data
        vm.$bus.fnShowInfo('設定成功')
        //先這樣關掉吧,cbSave是父組件負責存檔那樣先不要那樣做
        //一個一個改...有refresh!但如果是vm.Merchants[merchant.row_index] = merchant整個換掉就無法更新@_@
        // for (let i = 0; i <  ) {
          
        // }

        // vm.Stores[store.row_index].store_name = store.store_name
        // vm.Stores[store.row_index].store_contact_info = store.store_contact_info
        // vm.Stores[store.row_index].store_contact_info2 = store.store_contact_info2
        // vm.Stores[store.row_index].store_email = store.store_email
        // vm.Stores[store.row_index].addr_city = store.addr_city
        // vm.Stores[store.row_index].addr_area = store.addr_area
        // vm.Stores[store.row_index].addr_road_part = store.addr_road_part
        // vm.Stores[store.row_index].addr_rest = store.addr_rest
        // vm.Stores[store.row_index].store_address = store.store_address
        // vm.Stores[store.row_index].loc_desc = store.loc_desc
        // vm.Stores[store.row_index].header_custom_note = store.header_custom_note
        // vm.Stores[store.row_index].footer_custom_note = store.footer_custom_note
        // vm.Stores[store.row_index].business_time = store.business_time
        // vm.Stores[store.row_index].holiday = store.holiday
        // vm.Stores[store.row_index].map_zoom = Number(store.map_zoom)
        // vm.skip_merchant_cache = true
        // vm.showModal = false

        for (let i = 0; i < vm.Stores.length; i++) {

          if (store.account_name === vm.Stores[i].account_name) {
            // console.log([i]);
            // console.log(vm.Stores[i]);
            vm.Stores[i].store_name = store.store_name
            vm.Stores[i].store_contact_info = store.store_contact_info
            vm.Stores[i].store_contact_info2 = store.store_contact_info2
            vm.Stores[i].store_email = store.store_email
            vm.Stores[i].addr_city = store.addr_city
            vm.Stores[i].addr_area = store.addr_area
            vm.Stores[i].addr_road_part = store.addr_road_part
            vm.Stores[i].addr_rest = store.addr_rest
            vm.Stores[i].store_address = store.store_address
            vm.Stores[i].loc_desc = store.loc_desc
            vm.Stores[i].header_custom_note = store.header_custom_note
            vm.Stores[i].footer_custom_note = store.footer_custom_note
            vm.Stores[i].business_time = store.business_time
            vm.Stores[i].holiday = store.holiday
            vm.Stores[i].map_zoom = Number(store.map_zoom)
            vm.skip_merchant_cache = true
            vm.showModal = false
            break;
          }
          
        }

        console.log(vm.Stores);

      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          vm.isLoading = false
          return
        }
      })
      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   vm.$bus.fnShowInfo('設定成功')
      //   //先這樣關掉吧,cbSave是父組件負責存檔那樣先不要那樣做
      //   //一個一個改...有refresh!但如果是vm.Merchants[merchant.row_index] = merchant整個換掉就無法更新@_@
      //   vm.Stores[store.row_index].store_name = store.store_name
      //   vm.Stores[store.row_index].store_contact_info = store.store_contact_info
      //   vm.Stores[store.row_index].store_contact_info2 = store.store_contact_info2
      //   vm.Stores[store.row_index].store_email = store.store_email
      //   vm.Stores[store.row_index].addr_city = store.addr_city
      //   vm.Stores[store.row_index].addr_area = store.addr_area
      //   vm.Stores[store.row_index].addr_road_part = store.addr_road_part
      //   vm.Stores[store.row_index].addr_rest = store.addr_rest
      //   vm.Stores[store.row_index].store_address = store.store_address
      //   vm.Stores[store.row_index].loc_desc = store.loc_desc
      //   vm.Stores[store.row_index].header_custom_note = store.header_custom_note
      //   vm.Stores[store.row_index].footer_custom_note = store.footer_custom_note
      //   vm.Stores[store.row_index].business_time = store.business_time
      //   vm.Stores[store.row_index].holiday = store.holiday
      //   vm.skip_merchant_cache = true
      //   vm.showModal = false
      // }, this)
    },
    createStore(store) {
      let rptParam = {
        'module':'admin_manage',
        'method':'createStore',
        'merchant_id':this.FocusedMerchantId,
        'store_name': store.store_name,
        'is_super_manage':0,
        'store_contact_info': store.store_contact_info,
        'store_email': store.store_email,
        'store_contact_info2': store.store_contact_info2,
        'addr_city': store.addr_city,
        'addr_area': store.addr_area,
        'addr_road_part': store.addr_road_part,
        'addr_rest': store.addr_rest,
        'loc_desc': store.loc_desc,
        'header_custom_note': store.header_custom_note,
        'footer_custom_note': store.footer_custom_note,
        'business_time': store.business_time,
        'holiday': store.holiday,
        //後台的店長帳號暫時固定都是自動建立吧
        'account':'',
        'account_name':'',
        'password':''
      }
      let vm = this
      apiCreateStore(rptParam).then(function(resp){
        // let data = resp.data
        vm.$bus.fnShowInfo('設定成功')
        //先這樣關掉吧,cbSave是父組件負責存檔那樣先不要那樣做
        //一個一個改...有refresh!但如果是vm.Merchants[merchant.row_index] = merchant整個換掉就無法更新@_@
        vm.skip_merchant_cache = true
        vm.loadMerchantById(vm.FocusedMerchantId)
        vm.showModal = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          vm.isLoading = false
          return
        }
      })
      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   vm.$bus.fnShowInfo('設定成功')
      //   //先這樣關掉吧,cbSave是父組件負責存檔那樣先不要那樣做
      //   //一個一個改...有refresh!但如果是vm.Merchants[merchant.row_index] = merchant整個換掉就無法更新@_@
      //   vm.skip_merchant_cache = true
      //   vm.loadMerchantById(vm.FocusedMerchantId)
      //   vm.showModal = false
      // }, this)
    },
    saveMerchant(merchant) {
      let rptParam = {
        'module':'admin_manage',
        'method':'updateMerchant',
        'merchant_id': merchant.merchant_id,
        'invoice_type':merchant.invoice_type,
        'supplier_address':merchant.supplier_address,
        'person_in_charge':merchant.person_in_charge
      }
      //身份不對不設定匯款設定更新
      if (['sys_admin','mgr_dept'].includes(this.$bus.session.role_type)) {
        rptParam.remit_bank_no = merchant.remit_bank_no
        rptParam.remit_bankbranch_no = merchant.remit_bankbranch_no
        rptParam.remit_id = merchant.remit_id
        rptParam.remit_title = merchant.remit_title
        rptParam.remit_email = merchant.remit_email
        rptParam.remit_bank_cname = merchant.remit_bank_cname
        rptParam.remit_bankbranch_cname = merchant.remit_bankbranch_cname
        rptParam.remit_name = merchant.remit_name
        rptParam.remit_tel = merchant.remit_tel
        rptParam.remit_m_tel = merchant.remit_m_tel
        rptParam.remit_fax = merchant.remit_fax
        rptParam.identity_id = merchant.identity_id
      }

      let vm = this
      apiUpdateMerchant(rptParam).then(function(resp){
        let data = resp.data
        //就是parentRef了...所以不用管
        vm.$bus.fnShowInfo('設定成功')
        //先這樣關掉吧,cbSave是父組件負責存檔那樣先不要那樣做
        //一個一個改...有refresh!但如果是vm.Merchants[merchant.row_index] = merchant整個換掉就無法更新@_@
        vm.Merchants[merchant.row_index].invoice_type = merchant.invoice_type
        vm.Merchants[merchant.row_index].supplier_address = merchant.supplier_address
        vm.Merchants[merchant.row_index].person_in_charge = merchant.person_in_charge
        
        vm.Merchants[merchant.row_index].remit_bank_no = merchant.remit_bank_no
        vm.Merchants[merchant.row_index].remit_bankbranch_no = merchant.remit_bankbranch_no
        vm.Merchants[merchant.row_index].remit_id = merchant.remit_id
        vm.Merchants[merchant.row_index].remit_title = merchant.remit_title
        vm.Merchants[merchant.row_index].remit_email = merchant.remit_email
        vm.Merchants[merchant.row_index].remit_bank_cname = merchant.remit_bank_cname
        vm.Merchants[merchant.row_index].remit_bankbranch_cname = merchant.remit_bankbranch_cname
        vm.Merchants[merchant.row_index].remit_name = merchant.remit_name
        vm.Merchants[merchant.row_index].remit_tel = merchant.remit_tel
        vm.Merchants[merchant.row_index].remit_m_tel = merchant.remit_m_tel
        vm.Merchants[merchant.row_index].remit_fax = merchant.remit_fax
        
        vm.showModal = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          vm.isLoading = false
          return
        }
      })

      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   //就是parentRef了...所以不用管
      //   vm.$bus.fnShowInfo('設定成功')
      //   //先這樣關掉吧,cbSave是父組件負責存檔那樣先不要那樣做
      //   //一個一個改...有refresh!但如果是vm.Merchants[merchant.row_index] = merchant整個換掉就無法更新@_@
      //   vm.Merchants[merchant.row_index].invoice_type = merchant.invoice_type
      //   vm.Merchants[merchant.row_index].supplier_address = merchant.supplier_address
      //   vm.Merchants[merchant.row_index].person_in_charge = merchant.person_in_charge
        
      //   vm.Merchants[merchant.row_index].remit_bank_no = merchant.remit_bank_no
      //   vm.Merchants[merchant.row_index].remit_bankbranch_no = merchant.remit_bankbranch_no
      //   vm.Merchants[merchant.row_index].remit_id = merchant.remit_id
      //   vm.Merchants[merchant.row_index].remit_title = merchant.remit_title
      //   vm.Merchants[merchant.row_index].remit_email = merchant.remit_email
      //   vm.Merchants[merchant.row_index].remit_bank_cname = merchant.remit_bank_cname
      //   vm.Merchants[merchant.row_index].remit_bankbranch_cname = merchant.remit_bankbranch_cname
      //   vm.Merchants[merchant.row_index].remit_name = merchant.remit_name
      //   vm.Merchants[merchant.row_index].remit_tel = merchant.remit_tel
      //   vm.Merchants[merchant.row_index].remit_m_tel = merchant.remit_m_tel
      //   vm.Merchants[merchant.row_index].remit_fax = merchant.remit_fax
        
      //   vm.showModal = false
      // }, this)
    },
    sendNewAdmin(store) {
      // 發信給adm_tel,產生一個code請對方設定初始密碼
      let Param = {
        'module':'request_reset',
        'method':store.store_id,
        'useGet':true,
        'apiTarget':'rest'
      }
      let vm = this
      apiRequestReset(Param).then(function(resp){
        vm.$bus.fnShowInfo("已寄出簡訊連結由店家自行設定店長管理帳號的密碼")
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo(data.msg)
      //       return
      //     }
      //   vm.$bus.fnShowInfo("已寄出簡訊連結由店家自行設定店長管理帳號的密碼")
      // }, this)
    },
    closePopup () {
      this.showModal = false
      this.popupItem = ""
    },
    editMerchant (row) {
      this.FocusedMerchant = this.CpObj(row.item)
      this.FocusedMerchant.row_index = row.index
      this.popupItem = "MerchantInfo"
      this.modalSize = "lg"
      this.showModal = true
    },
    editStore (row) {
      console.log(row)
      this.FocusedStore = this.CpObj(row.item)
      this.FocusedStore.is_create = false
      this.FocusedStore.row_index = row.index
      this.popupItem = "StoreInfo"
      this.modalSize = "xl"
      this.showModal = true
    },
    createAdminAccount (row) {
      this.popupAccountFormObj = this.CpObj(row.item)
      this.popupAccountFormObj.action = 'create'
      this.popupAccountFormObj.account_name = this.popupAccountFormObj.store_name+"店長帳號"
      this.popupAccountFormObj.row_index = row.index
      this.popupItem = "AccountQuick"
      this.modalSize = "lg"
      this.showModal = true
    },
    editAdminPwd (row) {
      this.popupAccountFormObj = this.CpObj(row.item)
      this.popupAccountFormObj.action = 'updpwd'
      //不要殘留上次的密碼,每次都要重填
      this.popupAccountFormObj.password = ''
      this.popupAccountFormObj.password2 = ''
      this.popupItem = "AccountQuick"
      this.modalSize = "lg"
      this.showModal = true
    },
    createSubAccount () {
      // 自動產生帳號 自動用流水號產生 前端自己編
      // loop account列表,找到類型的最大流水號
      let base_account = ""
      let manager_last_seq = 0;
      let operator_last_seq = 0;
      for (let i=0;i<this.Accounts.length;i++) {
        if (this.Accounts[i].account_type == 'admin') {
          base_account = this.Accounts[i].account
        }
        if (this.Accounts[i].account_type == 'manager') {
          // 這個有風險,假設都是流水號產生店長帳號,則子帳號必為店長帳號後加A流水號
          if (parseInt(this.Accounts[i].account.substr(this.Accounts[i].account.indexOf('A')+1)) > manager_last_seq ) {
            manager_last_seq = parseInt(this.Accounts[i].account.substr(this.Accounts[i].account.indexOf('A')+1))
          }
        }
        if (this.Accounts[i].account_type == 'operator') {
          // 這個有風險,假設都是流水號產生店長帳號,則子帳號必為店長帳號後加B流水號
          if (parseInt(this.Accounts[i].account.substr(this.Accounts[i].account.indexOf('B')+1)) > operator_last_seq ) {
            operator_last_seq = parseInt(this.Accounts[i].account.substr(this.Accounts[i].account.indexOf('B')+1))
          }
        }
      }
      this.popupAccountFormObj = {
        action: 'create',
        merchant_store_id: this.FocusedMerchantStoreId,
        account: base_account+'A'+((manager_last_seq+1)+"").padStart(2,'0'),
        account_name: '',
        role: 'manager',
        password: '',
        password2: '',
        base_account: base_account,
        manager_last_seq: manager_last_seq,
        operator_last_seq: operator_last_seq
      },
      this.popupItem = "AccountInfo"
      this.modalSize = "lg"
      this.showModal = true
    },
    editSubAccount (row) {
      const role = (row.item.role_type === '店長管理者'?'admin':(row.item.role_type === '預約管理者'?'manager':'operator'))
      this.popupAccountFormObj = {
        action: 'update',
        account: row.item.account,
        account_name: row.item.account_name,
        merchant_account_id: row.item.merchant_account_id,
        role: role,
        password: '',
        password2: ''
      },
      this.popupItem = "AccountInfo"
      this.modalSize = "lg"
      this.showModal = true
    },
    editSubAccountPwd (row) {
      this.popupAccountFormObj = {
        action: 'updsubpwd',
        merchant_account_id: row.item.merchant_account_id,
        account: row.item.account,
        account_name: row.item.account_name,
        password: '',
        password2: ''
      },
      this.popupItem = "AccountQuick"
      this.modalSize = "lg"
      this.showModal = true
    },
    delSubAccount(row) {
      let Param = {
        'module':'merchant',
        'method':'deleteMerchantAccount',
        'merchant_account_id':row.item.merchant_account_id,
      }
      let vm = this
      apiDeleteMerchantAccount(Param).then(function(resp){
          vm.$bus.fnShowInfo("帳號刪除完成")
          // 立flag店長有變,回上層時要重撈
          if (row.item.role_type === '店長管理者') {
            vm.accountAdminDirty = true
          }
          //省麻煩reload全部子帳號啦
          vm.loadStoreAccounts(row.item.merchant_store_id)
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     vm.$bus.fnShowInfo("帳號刪除完成")
      //     // 立flag店長有變,回上層時要重撈
      //     if (row.item.role_type === '店長管理者') {
      //       vm.accountAdminDirty = true
      //     }
      //     //省麻煩reload全部子帳號啦
      //     vm.loadStoreAccounts(row.item.merchant_store_id)
      // },this)
    },
    changeSubAccountStatus(row) {
      let Param = {
        'module':'merchant',
        'method':'changeAccountStopStatus',
        'merchant_account_id':row.item.merchant_account_id,
        'change_status':row.item.status==='active'?'stop':'reopen',
      }
      let vm = this
      apiChangeAccountStopStatus(Param).then(function(resp){
        let data = resp.data
        //省麻煩reload全部子帳號啦
        vm.$bus.fnShowInfo("帳號更新完成")
        vm.loadStoreAccounts(row.item.merchant_store_id)
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     //省麻煩reload全部子帳號啦
      //     vm.$bus.fnShowInfo("帳號更新完成")
      //     vm.loadStoreAccounts(row.item.merchant_store_id)
      // },this)
    },
    loadMerchantsEnter() {
      if (this.filterMerchantFormObj.FilterMerchantName) {
        this.loadMerchants()
      }
    },
    loadMerchants () {
      let Param = {
        'module':'admin_manage',
        'method':'get_merchant_list',
        'merchant_name':this.filterMerchantFormObj.FilterMerchantName.trim(),
      }
      let vm = this
      apiGetMerchantList(Param).then(function(resp){
        let data = resp.data
          // eslint-disable-next-line
          vm.Merchants = data.data
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     vm.Merchants = data.data
      // },this)
    },
    goMerchant(row) {
      setTimeout(() => {
        this.filterStoreFormObj.is_open_stores_only = true
        this.FocusedMerchantId = row.item.merchant_id
        this.loadMerchantById(row.item.merchant_id)
        this.Mode = "MerchantStore"
      }, 300);
    },
    loadMerchantById(merchant_id) {
      // 回到預設
      this.Stores = []
      this.SelectedStoreId = null
      // 先判斷cache
      if (this.skip_merchant_cache == false && this.CachedMerchant.hasOwnProperty('m_'+this.FocusedMerchantId)) {
        this.FocusedMerchant = this.CachedMerchant['m_'+this.FocusedMerchantId]
        this.Stores = this.FocusedMerchant.merchant_stores
        this.FilteredStores = this.Stores
      }
      else {
        this.FocusedMerchantId = merchant_id
        // 再抓資料庫放cache
        let Param = {
          'module':'admin_manage',
          'method':'get_merchant_by_id',
          'merchant_id':merchant_id,
        }
        let vm = this
        apiGetMerchantById(Param).then(function(resp){
          let data = resp.data
          vm.FocusedMerchant = vm.CpObj(data.data)
          vm.Stores = data.data.merchant_stores
          vm.FilteredStores = vm.Stores
          vm.CachedMerchant['m_'+vm.FocusedMerchantId] = data.data
          vm.skip_merchant_cache == false
          vm.filterStore()
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
          }
        })
        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0) {
        //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //       return
        //     }
        //     vm.FocusedMerchant = vm.CpObj(data.data)
        //     vm.Stores = data.data.merchant_stores
        //     vm.FilteredStores = vm.Stores
        //     vm.CachedMerchant['m_'+vm.FocusedMerchantId] = data.data
        //     vm.skip_merchant_cache == false
        // },this)
      }
    },
    backToMerchantList() {
      this.FocusedMerchantId = 0
      this.filterStoreFormObj.FilterStore = ""
      this.$refs.filterStoreForm.refreshModelVar('FilterStore')
      setTimeout(() => {
        this.Mode = "Merchant"
      }, 300);
    },
    filterStore () {
      console.log('here', this.filterStoreFormObj)

      this.FilteredStores = []
      for (let i = 0;i < this.Stores.length; i++) {
        // 過濾掉 服務關閉的店家
        if (this.filterStoreFormObj.is_open_stores_only) {
          if (this.Stores[i].is_open === 0) {
            continue
          }
        }

        // 過濾掉 店名不符合的店家
        if (this.filterStoreFormObj.FilterStore) {
          if (this.Stores[i].store_name.indexOf(this.filterStoreFormObj.FilterStore) === -1) {
            continue
          }
        }

        this.FilteredStores.push(this.Stores[i])
      }

    },
    refreshAccounts() {
      this.loadStoreAccounts(this.FocusedMerchantStoreId)
    },
    loadStoreAccounts (store_id) {
      // 回到預設
      this.Accounts = []
      this.FocusedMerchantStoreId = store_id
      // 再抓資料庫放cache
      let Param = {
        'module':'merchant',
        'method':'get_account_list',
        'store_id':this.FocusedMerchantStoreId,
      }
      let vm = this
      apiGetAccountList(Param).then(function(resp){
        let data = resp.data
        // eslint-disable-next-line
        vm.Accounts = data.data.result_accounts
        vm.FilteredAccounts = vm.Accounts
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     vm.Accounts = data.data.result_accounts
      //     vm.FilteredAccounts = vm.Accounts
      // },this)
    },
    goAccount(row) {
      setTimeout(() => {
        this.FocusedStore = row.item
        this.accountAdminDirty = false
        this.loadStoreAccounts(row.item.id)
        this.Mode = "MerchantAccount"
      }, 300);
    },
    backToStoreList() {
      if (this.accountAdminDirty) {
        delete this.CachedMerchant['m_'+this.FocusedMerchantId]
        this.loadMerchantById(this.FocusedMerchantId)
        this.accountAdminDirty = false
      }      
      setTimeout(() => {
        this.Mode = "MerchantStore"
      }, 300);
    },
  },
  computed:{
    scrollHint: {
      cache:false,
      get() {
        switch (this.Mode) {
          case 'Merchant':
            return '回到頂端(總數'+this.Merchants.length+')'
          case 'MerchantStore':
            return '回到頂端(總數'+this.Stores.length+')'
          case 'MerchantAccount':
            return '回到頂端(總數'+this.Accounts.length+')'
        }
      }
    }
  },
  created () {
    if (!this.$bus.session) {
      this.$bus.session = undefined
    }
    // 根據角色決定初始role
    if (this.$bus.getRole() === 'admin') {
      this.Mode = "Merchant"
    }
    else if (this.$bus.getRole() === 'merchant' && this.$bus.session && this.$bus.session.is_super_manage) {
      this.Mode = "MerchantStore"
      this.FocusedMerchant = {
        'merchant_id':this.$bus.session.merchant_id,
        'merchant_name':this.$bus.session.merchant_name,
      }
      this.FocusedMerchantId = this.$bus.session.merchant_id
      this.loadMerchantById(this.FocusedMerchantId)
    }
    else {
      if (!this.$bus.session) {
        // 導到登入
        this.$bus.session
        return
      }
      this.Mode = "MerchantAccount"
      this.FocusedMerchant = {
        'merchant_id':this.$bus.session.merchant_id,
        'merchant_name':this.$bus.session.merchant_name,
      }
      this.FocusedMerchantStoreId = this.$bus.session.merchant_store_id
      this.FocusedStore = {
        'id':this.$bus.session.merchant_store_id,
        'store_name':this.$bus.session.store_name,
      }
      this.loadStoreAccounts(this.$bus.session.merchant_store_id)
    }
  },
  mounted () {
    // 未初始化時預設值會是undefined,需注意呼叫api的參數處理
    this.$refs.filterMerchantForm.initDefault()
    this.$refs.filterStoreForm.initDefault()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
